import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { Organization } from './types';

type Variables = { slug: string };
type Response = Organization;

export const useOrganization = createQuery<Response, Variables, AxiosError>({
  queryKey: ['organization'],
  fetcher: ({ slug }) => {
    return client
      .get(`v1/organizations/${slug}`)
      .then((response) => {
        return response.data;
      })
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      });
  },
});
